import Api from './api'
import Cache from './cache'

const DataCache = new Cache('data')
const RequestCache = new Cache('request')

const DataProviderService = {
  cached(dateRange) {
    return DataCache.get(DataProviderService.cacheKey(dateRange))
  },

  cacheKey({ start, end }) {
    return `${start}-${end}`
  },

  get(dateRange) {
    return dateRange.isSingleDay()
      ? DataProviderService.getDay(dateRange)
      : DataProviderService.getWeek(dateRange)
  },

  dateParam(date) {
    return encodeURIComponent(date)
  },

  weekParams(start, end) {
    return {
      params: {
        start: encodeURIComponent(start),
        end: encodeURIComponent(end)
      }
    }
  },

  getDay({ start, end, date }) {
    let path = `/daily/${DataProviderService.dateParam(date)}`

    return (
      RequestCache.get(path) || DataProviderService.request(path, start, end)
    )
  },

  getWeek({ start, end }) {
    let path = `/weekly/${DataProviderService.dateParam(start)}`

    return (
      RequestCache.get(path) || DataProviderService.request(path, start, end)
    )
  },

  request(path, start, end) {
    let request = Api.get(path, { cancelKey: 'calendar' }).then(response => {
      // The promise for a cancelled request can be fulfilled with an
      // empty value if the request was cancelled by axios due to a
      // subsequent newer request. In that case we want to purge the
      // request from the RequestCache.
      if (!response) {
        RequestCache.clear(path)
      } else {
        DataCache.set(
          DataProviderService.cacheKey({ start, end }),
          response.data
        )

        return response.data
      }
    })

    RequestCache.set(path, request)

    return request
  }
}

export default DataProviderService
